<template>
  <div class="container__head">
    <div class="first">
      <img src="../assets/logo.svg" alt="Huddle logo" />
      <button class="try__free">Try It Free</button>
    </div>
    <div class="total">
      <div class="info">
        <h1 class="tittle">Build The Community Your Fans Will Love</h1>
        <p class="description">
          Huddle re-imagines the way we build communities. You have a voice, but
          so does your audience. Create connections with your users as you
          engage in genuine discussion.
        </p>
        <button class="started__free">Get Started For Free</button>
      </div>
      <img
        src="../assets/illustration-mockups.svg"
        alt="mockups"
        class="principal__img"
      />
    </div>
  </div>
</template>

<script>
export default {
  setup() {},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.container__head {
  background-color: #ebfbff;
  background-image: url("../assets/bg-hero-mobile.svg");
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: top;
  background-size: contain;
  width: 100%;
  height: 700px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.first {
  width: 90%;
  height: 70px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.first img {
  width: 100px;
}

.try__free {
  width: 100px;
  height: 25px;
  border-radius: 15px;
  cursor: pointer;
  background: white;
  color: black;
  font-family: "Poppins", sans-serif;
  border: none;
  font-size: 10px;
  font-weight: 700;
  -webkit-box-shadow: 0 2px 5px rgba(128, 141, 153, 0.3);
  box-shadow: 0 2px 5px rgba(128, 141, 153, 0.3);
}

.try__free:hover {
  color: rgba(128, 141, 153, 0.9);
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.total {
  margin-top: 60px;
  width: 90%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.info {
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.tittle {
  width: 90%;
  font-size: 25px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.description {
  width: 92%;
  margin-top: 30px;
  font-size: 17px;
  font-family: "Open Sans", sans-serif;
}

.started__free {
  margin-top: 30px;
  width: 240px;
  height: 40px;
  border-radius: 20px;
  background: #ff52bf;
  -webkit-box-shadow: 3px 6px rgba(128, 141, 153, 0.1);
  box-shadow: 3px 6px rgba(128, 141, 153, 0.1);
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
  border: none;
}

.started__free:hover {
  opacity: 0.7;
  -webkit-transform: translateY(-1px);
  transform: translateY(-1px);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.principal__img {
  margin-top: 50px;
  width: 95%;
}

@media (min-width: 481px) {
  .principal__img {
    width: 420px;
  }
}

@media (min-width: 768px) {
  .container__head {
    height: 580px;
  }
  .first {
    height: 140px;
  }
  .first img {
    width: 150px;
  }
  .try__free {
    width: 150px;
    height: 40px;
    border-radius: 20px;
    font-size: 13.5px;
  }
  .tittle {
    width: 260px;
  }
  .principal__img {
    width: 55%;
  }
  .total {
    margin: 0;
    width: 90%;
    height: 100%;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }
  .info {
    text-align: left;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
  }
}

@media (min-width: 1024px) {
  .container__head {
    background-color: #ebfbff;
    background-image: url("../assets/bg-hero-desktop.svg");
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: contain;
  }
  .principal__img {
    width: 510px;
  }
}

@media (min-width: 1200px) {
  .container__head {
    height: 600px;
  }
  .description {
    width: 460px;
  }
  .first {
    width: 1100px;
  }
  .total {
    width: 1100px;
  }
}

@media (min-width: 1440px) {
  .first img {
    width: 200px;
  }
  .try__free {
    width: 180px;
  }
  .tittle {
    width: 500px;
    font-size: 40px;
  }
  .description {
    width: 550px;
    font-size: 19px;
  }
  .container__head {
    height: 630px;
  }
  .principal__img {
    width: 600px;
    margin-right: 20px;
  }
  .first {
    width: 1300px;
  }
  .total {
    width: 1300px;
    margin-bottom: 40px;
  }
}
</style>
